import { isMpsSupport, isPatientOrMember } from "../../security/roles";

// A public channel link is mypatientspace.com/a/p/<patientId>. The path segment is
// the channel account's login username; every public channel account shares this
// password. It is baked into the bundle either way, so an env override only buys
// per-environment rotation, not secrecy — the backend has to treat these accounts
// as anonymous-grade.
export const PUBLIC_CHANNEL_PASSWORD =
  process.env.REACT_APP_PUBLIC_CHANNEL_PASSWORD || "p5UmTLn57jL@26";

// Which backend a public channel link signs in against. On localhost the app
// otherwise talks to whichever backend the developer last picked (the LOCAL one
// by default); a local visit to a public link always uses preprod instead.
// Deployed hosts are left alone — config resolves production on web., UAT on
// uat., and so on from the domain. Returns the URL to switch to, or null when
// the current resolution should stand.
const PUBLIC_CHANNEL_LOCAL_REGION = "preprod";

// Matches how src/config decides it is running locally.
const isLocalDevelopmentHost = (hostname) => hostname === "localhost";

export const getLocalPublicChannelApiUrl = (hostname, regions = []) => {
  if (!isLocalDevelopmentHost(hostname)) {
    return null;
  }
  const region = regions.find(
    (candidate) => candidate.regionCode === PUBLIC_CHANNEL_LOCAL_REGION
  );
  return region ? region.url : null;
};

// Where the app's own route wrappers would send this role after a normal login
// (userIsNotAuthenticated in src/index.js). A channel account is always a
// patient; the other two are for the header popover, where the visitor can sign
// in as any kind of user.
export const getPublicChannelLanding = (role) => {
  if (isMpsSupport(role)) {
    return "/mps-patients";
  }
  return isPatientOrMember(role) ? "/app" : "/";
};

// True when the persisted session already belongs to the link's account, so the
// visitor can go straight in without a second login.
export const isLoggedInAs = (user, username) =>
  !!(user && user.loggedIn && user.data && user.data.loginUserId === username);
